import {
  Button,
  Col,
  Flex,
  Form,
  Radio,
  Row,
  Space,
  Switch,
  Typography,
} from 'antd'
import { acceptedRule, requiredRule } from '../../../helpers/rules'
import { Industry } from '../../../models/Industry'
import IndustryCard from '../IndustryCard'
import { useEffect, useState } from 'react'
import { SBAPIFetchPaginated } from '../../../helpers/SBAPIHelper'
import { INDUSTRIES_URL } from '../../../helpers/urls'
import { Link } from 'react-router-dom'
import i18n from '../../../i18n/setupLocalization'
import LocalizationKeys from '../../../i18n/LocalizationKeys'
import { Trans } from 'react-i18next'

const { Title, Text } = Typography

const IndustryStep = () => {
  const industryWatch = Form.useWatch('industry')
  const gpdrWatch = Form.useWatch('gpdr')
  const [industries, setIndustries] = useState<Industry[]>([])

  useEffect(() => {
    SBAPIFetchPaginated<Industry[]>(INDUSTRIES_URL, {
      pagination: { current: 1, pageSize: 1000 },
    }).then((data) => setIndustries(data.data.reverse()))
  }, [])
  return (
    <Flex vertical>
      <Form.Item
        validateTrigger={false}
        label={
          <Title className="m-0" level={5}>
            {i18n.t(
              LocalizationKeys.Page.OnboardingStepsIndustryPage.FieldActivity
            )}
          </Title>
        }
        name={'industry'}
        rules={[requiredRule()]}
      >
        <Radio.Group block style={{ marginTop: 15 }}>
          <Row gutter={[16, 16]}>
            {industries.map((industry) => (
              <Col key={industry.id} xs={24} sm={24} md={12}>
                <IndustryCard industry={industry} />
              </Col>
            ))}
          </Row>
        </Radio.Group>
      </Form.Item>
      {industryWatch != undefined && (
        <Flex vertical gap={16}>
          <Space className="w-full" size={15}>
            <Form.Item
              name={'gpdr'}
              rules={[requiredRule(), acceptedRule()]}
              className="m-0"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Text>
              <Trans
                i18nKey={
                  LocalizationKeys.Page.OnboardingStepsIndustryPage.CheckMention
                }
                components={[
                  <Link key={0} target="_blank" to="/legal/cgu" />,
                  <Link
                    key={1}
                    target="_blank"
                    to="/legal/data-privacy-policy"
                  />,
                ]}
              />
            </Text>
          </Space>
          <Button
            htmlType="submit"
            style={{ marginBottom: 50 }}
            size="large"
            type="primary"
            disabled={!gpdrWatch || industryWatch == undefined}
          >
            {i18n.t(LocalizationKeys.Page.OnboardingStepsIndustryPage.Continue)}
          </Button>
        </Flex>
      )}
    </Flex>
  )
}

export default IndustryStep
